import React, { useEffect } from 'react';

/**
 * Ventana modal centrada, sobre las clases que ya existen en global.css
 * (.modal-overlay, .modal, .modal-header...).
 *
 * - Se cierra con Escape o pulsando el fondo.
 * - Mientras esta abierta, la pagina de detras no se desplaza: sin esto, al
 *   girar la rueda del raton se mueve el listado y se pierde la referencia.
 *
 * @param {string}   titulo
 * @param {function} onCerrar
 * @param {node}     pie      Botones de accion. Van en un pie fijo para que
 *                            no se pierdan si el cuerpo necesita scroll.
 * @param {number}   ancho    Ancho maximo en px.
 */
export default function Modal({ titulo, onCerrar, children, pie, ancho = 560 }) {
  useEffect(() => {
    const alTeclear = (e) => { if (e.key === 'Escape') onCerrar(); };
    document.addEventListener('keydown', alTeclear);

    const desbordePrevio = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', alTeclear);
      document.body.style.overflow = desbordePrevio;
    };
  }, [onCerrar]);

  return (
    <div className="modal-overlay" onClick={onCerrar}>
      <div
        className="modal"
        style={{ maxWidth: ancho }}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={titulo}
      >
        <div className="modal-header">
          <span className="modal-title">{titulo}</span>
          <button className="btn btn-ghost" style={{ padding: '2px 9px' }}
                  onClick={onCerrar} aria-label="Cerrar">✕</button>
        </div>

        <div className="modal-body">{children}</div>

        {pie && <div className="modal-footer">{pie}</div>}
      </div>
    </div>
  );
}
